import { render, staticRenderFns } from "./cl-tx-tab.vue?vue&type=template&id=6729dae7"
import script from "./cl-tx-tab.vue?vue&type=script&lang=js"
export * from "./cl-tx-tab.vue?vue&type=script&lang=js"
import style0 from "./cl-tx-tab.vue?vue&type=style&index=0&id=6729dae7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports